<template>
	<div>
		<AgencyBanner />
		<div class="content-zsy">
			<div class="agency-config-common">
				<h3>
					구매대행 신청
				</h3>
				<div class="type-card shadow-bottom">
					<div class="card-head">구매대행 신청서 작성시 주의사항</div>
					<div class="card-body">
						<div class="card-help">물품의 검수, 항공운송, 통관 및 국내배송상 제한되는 내용등이 명기되어 있으니 상세히 읽어주시고 내용에 동의해주시기 바랍니다.</div>
						<div class="agreement-box">
							<div class="height-fixed-box">
								<p>1. 구매대행 신청 후 5회 이상&nbsp;구매 취소(단순 변심) 혹은&nbsp;미결제를&nbsp;하실 경우&nbsp;구매대행 서비스가&nbsp;지연될 수&nbsp;있습니다.<br><br>2.&nbsp;할인 상품의&nbsp;경우&nbsp;결제 이후&nbsp;상품 가격&nbsp;상승으로 주문 취소될 수 있으며 단기간 할인하는 상품은 구매대행 접수를 자제하여 주시기 바랍니다.<br><br>3. 국내외의&nbsp;법 위반물품,&nbsp;수출, 수입이 어렵거나 불가한 상품 은 구매대행이 불가합니다.<br><br>4. 지적재산권 침해 상품은 1차적으로 고로켓고에서 구매대행 취소 안내를 드리오나, 해당 안내를 받지 못하셨더라도<br>&nbsp; &nbsp;통관에 불이익이 있을 경우&nbsp;고로켓고&nbsp;책임이 없음을 안내드립니다.</p>
								<p>5. 구매대행의 경우 회원님께서 제공하여 주신 상품정보를 기초로 고로켓고에서 구매를 대행해드리는 것으로 구매대행 상품의<br>&nbsp; &nbsp;품질보증은 불가합니다. 회원님의 신중한 구매 바랍니다.<br><br>6. 1개의 계정당 아이템번호 기준 10개까지만 당일 구매대행 신청 가능하며 초과 신청 시 구매지연될 수 있습니다.<br><br>7. 구매대행 신청 후 판매자 일시&nbsp;재고 부족이나&nbsp;여러 사유로 인하여 구매대행 진행이 이루어지지 않을 수 있습니다.<br>&nbsp; &nbsp;이 경우 계좌 환불 또는 팀머니(예치금) 지급, 카드 취소일 경우 영업일로부터 2~3일 후 입금됩니다.</p>
								<p>8. 구매대행 신청 후 상품값을 결제하신 다음 즉시 배송대행 신청서를&nbsp;작성해 주셔야&nbsp;상품 도착 후 원활한 진행이 가능합니다.<br><br>9. 구매대행 상품 과 신청서 ,&nbsp; 배송대행 상품 과 신청서는&nbsp; 합배송이 불가합니다.<br><br><span style="font-size: 14pt;"><strong><span style="background-color: #ffffff;"><a style="background-color: #ffffff;" href="/shoppingGuide">구매대행 안내 바로가기</a></span></strong></span><br><br><br>이외&nbsp; 주의사항은 '배송신청서&nbsp;작성 시&nbsp;주의사항'을 반드시 확인하시어 불이익이 발생하지 않도록 주의&nbsp;당부드립니다.<br><br><br><span style="font-size: 14pt; color: #3366ff;"><strong>배송신청서 작성 시 주의사항</strong></span><br><br>배송대행 신청서&nbsp;작성 시&nbsp;주의사항<br><br>1.&nbsp;(신청서는&nbsp;상품 구매 후&nbsp;즉시 정확하게&nbsp;작성해 주세요)&nbsp;<br>회원님께서&nbsp;작성해 주시는&nbsp;신청서를 기준으로 입고/검수/포장/배송/통관&nbsp;기타 등등의&nbsp; 업무를 처리합니다.<br>신천서 미 작성 시&nbsp;모든 업무처리가 불가/지연됩니다.<br>1개의 배송신청서 상 서로 다른 트래킹번호 5 (가지) 까지 무료<br>1개의 배송신청서 상 서로 다른 트래킹번호 5 (가지) 초과 시, 추가된 트래킹번호 1가지 당 500원 청구<br>신청서는 국내&nbsp;통관 시&nbsp;세관 신고서에 그대로&nbsp; 반영되는 사항이므로 허위 작성으로 인한 모든 책임은 본인에게 있습니다.<br>신청서 미작성 후 도착하는 상품들은 노데이터로 처리되어 노데이터 구역 이동 처리 지연, 30일 경과 시 임의 폐기 등의 상황이 발생됩니다.<br>&nbsp;<a href="/bizAddService"> [사업자](부가서비스 안내 바로가기)</a><br>신청서 상에 상품에 대한 충분한 정보 (상품 이미지, url, 트레킹 번호, 색상, 사이즈, 수량)를 입력해 주셔야 합니다 정보가 부족하여 발생한 신청 건에 대해 고로켓고은 어떠한 책임도 지지 않습니다.<br>&nbsp;<br>2. ( 트래킹번호를 정확히 입력해 주세요)<br>상품 구매 후 판매자가 업로드하는 트래킹번호(중국 택배 송장번호)를 마이페이지&gt;신청서 아이템 목록에 입력해 주세요.&nbsp;<br>트래킹번호 입력이 안된 상태로 도착 시 노데이터로 처리되어 노데이터 구역 이동 처리 지연, 30일 경과 시 임의 폐기 등의 상황이 발생됩니다. (사업자 회원은 90일 무료 보관) 90일 초과 시 임의 폐기 처리됩니다.<br>* 상품 입고 정정 요청 시에는 부가 수수료가 발생될 수 있습니다. [홈페이지 (개인) -&gt;부가서비스 -&gt; 1. 분리/입고정정 수수료]<br><br><br>3. (배송비용)<br>국제 운송료는 특송과 화물로 분류되며 회원 등급과 신청 구분에 따라 배송비가 책정됩니다.<br>배송비 적용 시&nbsp;포장완료 건&nbsp;기준으로 크기와 중량에 따라&nbsp;&nbsp;국제 배송비 및&nbsp;선택&nbsp;부가 수수료와&nbsp;국내&nbsp;택배 할증요금이&nbsp;청구 됩니다.&nbsp;<br>(LCL 화물 운송은&nbsp;국내 택배 할증&nbsp;해당사항&nbsp;없음)(국내 택배&nbsp;할증요금&nbsp;보러 가기)<br>또한&nbsp;국제 배송비는&nbsp;포장완료 후&nbsp;부피/중량 중&nbsp;큰 쪽으로&nbsp;청구될 수&nbsp;있으며(LCL 화물 운송은&nbsp;해당사항 없음),&nbsp;중량별&nbsp;배송 요금은&nbsp;당사&nbsp;운임 정책에&nbsp;따라&nbsp;변경될 수&nbsp;있습니다.<br><br>4. (입고/검수/포장)<br>검수로 확인이 어려운 미세&nbsp;스크래치, 오염, 훼손, 올 풀림, 구성품 확인 불가&nbsp;등이&nbsp;발생할 수 있으며&nbsp;이는&nbsp;보상 대상이&nbsp;아닙니다.<br>검수를 위한 개봉으로 인한&nbsp;상품 가치&nbsp;하락,&nbsp;훼손, 오염, 구성품의&nbsp;분실 등이&nbsp;발생할 수&nbsp;있으며 이는&nbsp;보상 대상이&nbsp;아닙니다.<br>개봉 검수를 원치 않을 경우 [검수안함]을 선택해 주세요.(항공 운송건은 검수안함 선택 시에도 항공 안전 관련하여 개봉될 수 있습니다)<br>신청하신 검수&nbsp;옵션에 따라&nbsp;제공된&nbsp;도착 사진이&nbsp;검수로 대체되오니 반드시 직접&nbsp;확인해 주셔야&nbsp;하며,&nbsp;확인 완료 후&nbsp;배송신청 시&nbsp;입고/검수/포장의&nbsp;동의한 것으로&nbsp;간주되며 이는&nbsp;보상 대상이&nbsp;아닙니다.<br>포장 또한 신청 선택하신 옵션으로 포장&nbsp;제공해 드리며&nbsp;포장 보완을&nbsp;신청하지&nbsp;않을 경우&nbsp;각종&nbsp;파손 보상에서&nbsp;제외됩니다.<br>상품이 고로켓고 중국 물류센터 도착 후 현지 물동량에 따라 평균 입고/검수 1일 이내, 배송 요청 후 평균 1일 이내 포장완료되어 배송비 결제 요청됩니다.<br>(단일 배송 상품은&nbsp;입고, 검수, 포장,&nbsp;배송비 결제 요청까지 평균&nbsp;1일 소요)<br>평균 작업일&nbsp;이내에&nbsp;재촉 문의는&nbsp;답변이&nbsp;지연되는 점&nbsp;양해 바랍니다.<br><br>5.&nbsp;(구매/배송 금지)<br>해당 국가의&nbsp;관련 법을&nbsp;위반하는 상품의&nbsp;구매, 배송, 보관 등을&nbsp;하여 발생되는&nbsp;모든 책임은&nbsp;신청자 본인에게 있습니다.<br>한 쇼핑몰에서 한 번에 결제하고 주문한 상품들은 여러 개의 상품들이라도 배송 신청서를 하나에 모두 작성하며 상품들이 나뉘어 발송되어도 고로켓고에서 한 개의 포장 가능 범위 내에서 재포장 후 발송해 드립니다.<br>여러 쇼핑몰에서 구매하시거나, 같은 쇼핑몰이라고 해도 결제를 각각 한 다른 주문 건은 배송 신청서를 각각 등록하셔야 하며, 합배송을 신청하시면 한 박스로 포장되어 출고합니다.<br>단 합배송의 경우 하나의 계정(ID)에 한하여 합배송됩니다.<br>판매자 발송 이후 현지 내륙 배송기간과 상품의 품질은 고로켓고과 관련 없습니다.<br>&nbsp;<br>6.&nbsp;(선적 금지)<br>항공기, 선박에&nbsp;선적 금지&nbsp;물품 등을&nbsp;선적 요청하여&nbsp;선적 불가로&nbsp;인하여&nbsp;해당국 관련 법에 의해&nbsp;폐기 또는&nbsp;반송비용,&nbsp;과태료 등이&nbsp;발생할 수&nbsp;있으며&nbsp;이 경우&nbsp;신청 회원님의&nbsp;책임입니다.<br><br>7. (배송기간)<br>고로켓고에서 출고 이후 선적국/도착국/각국 세관/항공사/해운사/국내 택배사/화물 운송사/천재지변/불가항력 상황 등등에 따라서 배송시간이 다를 수 있습니다 이는 고로켓고이 개입하여&nbsp;<br>처리할 수 없는 부분입니다 이에 따른 불이익은 보상 대상이 아닙니다.<br>&nbsp;<br>8. (부가서비스)<br>신청서 작성 시 각 부가서비스 별로 옵션/비용/안내사항을 반드시 확인 신청해 주시기 바랍니다. [개인] (부가서비스 안내 바로가기) &nbsp;[사업자](부가서비스 안내 바로가기)<br>하나의 배송대행 신청서에 등록된 상품은 하나의&nbsp; 포장으로 운임이 청구되고, 배송됩니다 (사업자 회원의&nbsp;LCL 화물은&nbsp;상이). 단 상품의 크기와 요청 옵션에 따라 추가 비용이 발생될 수 있습니다.&nbsp;<br>무료로 제공하는 서비스와 홈페이지에 명시된 공지사항/배송요금/부가서비스/게시판 및 기타 안내사항을 숙지하지 못하여 발생되는 회원님의 손실에 대해서는 책임지지 않습니다.<br>&nbsp;<br>9.&nbsp;(통관 관련&nbsp;안내를 확인하세요)<br>홈페이지에 안내된 통관안내를 미리 확인하셔서 수입금지 및 수입통관 불가 상품들과 불법물품들을 구입/배송신청을 하시면 안 됩니다.<br>고로켓고은 회원님의 불법적인 요구는 협조하지 않습니다.<br>신청서를 실수/허위 작성하여 발생하는&nbsp;모든 책임은&nbsp;신청 작성자&nbsp;본인에게 있습니다.<br>샘플을 무료로 받은 물품도 모두 신청서 상에 정확한 품목명을 기재하시고 물품을 받으셔야 합니다.<br>무료라고 하더라도 최소 1위안 이상으로 기재해 주셔야 하며, 면세범위가 초과되는 경우 과세&nbsp;추징될&nbsp;수 있습니다.<br>세관 수입 통관 시에 물품을 1+1으로 받아서 하나를 무료로 받았다고 하더라도, 고객님께서 판단하에 금액을 반반씩 기재할 수는 있지만<br>실제 그 물품의&nbsp;판매 가격으로&nbsp;신고를 하셔야 합니다.&nbsp;불성실 신고&nbsp;시 세관에서 과세&nbsp;추징될&nbsp;수 있는 점 참고 부탁드립니다.<br>실제 입항되는 상품들을 모두&nbsp;배송 신청서에&nbsp;기재하여 주셔야 하며 신청서에 없는 상품이 입항될 경우 담당 세관원에 의해 인보이스 재 작성 및 사유서, 가격자료 등을&nbsp;요구받을&nbsp;수 있습니다.<br>고로켓고&nbsp;신청서 번호가&nbsp;다르다 하더라도 동일한 날짜에 한국에 입항한 건은 모두&nbsp;합산 처리가&nbsp;되며 이에 발생한 세금은 고객님 부담입니다.<br>자가 사용 기준&nbsp;&nbsp;총 구매 비용&nbsp;$150이 내는&nbsp;무료 목록통관으로 진행되며&nbsp;목록 취하&nbsp;될 경우&nbsp;추가 비용이&nbsp;발생됩니다.&nbsp;<br>자가 사용목적이&nbsp;아닌 경우&nbsp;반드시&nbsp;사업자 통관으로&nbsp;진행하셔야 하며&nbsp;관부가세 등&nbsp;추가 비용이&nbsp;발생됩니다.<br>통관 보류:&nbsp;수입금지품목, 지적재산권 침해 상품, 가격&nbsp;상이, 품명&nbsp;상이,&nbsp;수량 과다,&nbsp;검역 등으로 인하여 국내 통관이 보류될 수 있으며 통관 보류 시 관세청의 추가 수수료 발생 및 폐기처분 될 수 있습니다.<br>합산과세: 동일한 수취인 명의로 2건 이상의 상품이 동일한 날짜에 입항되는 경우 합산과세가 발생하며, 예측 불가능한 기상악화, 중국 내 세관 검사 등의&nbsp;입항 지연으로&nbsp;발생되는 합산과세&nbsp;보상 대상이&nbsp;아닙니다.<br>(통관안내 바로가기)<br>&nbsp;<br>10.&nbsp;(공지사항 확인하기)<br>반드시 공지사항/배송요금/부가서비스/게시판 및 기타 안내사항 등 을 확인하셔야 합니다 관련 사항 미확인으로 불이익이 발생될 수 있으며 이 경우 고로켓고의 책임 의무가 없습니다.<br>&nbsp;<br>11. (국내&nbsp;택배 정책)<br>국내 택배사의&nbsp;정책에 따라 아래 내용 중 1개라도 해당되는 상품은&nbsp;일반 택배&nbsp;이용이 불가하여<br>중형화물(경동 등) 택배나 독차 배송에 의해 배송이 이뤄지며 착불로&nbsp;발송되거나&nbsp;추가 요금이&nbsp;발생할&nbsp;수 있습니다.<br>이 경우&nbsp;국제 배송비용에&nbsp;포함된&nbsp;택배 비용은&nbsp;환불 대상이&nbsp;아닙니다.<br>1. 상품포장의 가로, 길이, 높이를 합산한 총 길이가 160cm 초과<br>2. 중량이 20kg 초과<br>3. 최장변의 길이가 100cm 초과하는 경우<br>4. 위 1~3번 기준에 근접한 기준으로 택배분류 기사님 재량에 따라 거부한 경우<br>5. 원통형,마대포장,나무 특수포장 등 이형화물의 경우<br>6. 세관 창고 현장 상황에 따라 상이<br>7.도서,산간지역은 국내택배사 추가비용이 발생합니다<br>&nbsp;<br>위 주의사항에 동의를 하고 배송대행/구매대행을 신청함에 따라 주의사항 미숙지로 인한 불이익에 어떠한 이의를 제기할 수 없습니다.<br><br>※고객센터는 평일 오전 10시 00분부터 오후 17시 00분까지 운영하며(점심 12시~13시 ) 운영시간 이외에는 다음날 순차적으로 답변됨에 따라 답변이 지연될 수 있습니다.<br>&nbsp;</p>
								
							</div>  
							
						</div>
						<div class="checkbox">
							<label class="checkbox-inline background-color">
								<!-- <input name="agreement_yn" type="checkbox" class="type-checkbox" value="1"> -->
								<el-checkbox v-model="checked" @change="agreementYn" ></el-checkbox>
								<span class="color-red">(필수)</span> 주의사항을 모두 확인하였으며, 위 사항에 동의합니다.  
							</label>
						</div>
					</div>
					
				</div>
				
				<div class="type-card shadow-bottom">
					<div class="card-head">배송방법 선택</div>
					<div class="card-body">
						<div class="card-help">배송일정은 천재지변, 결항, 항공사, 선사, 항만, 공항, 해당국 세관의 사정에 따라 달라질 수 있습니다.</div>
						
						<el-row>
							<el-col :xs="24" :sm="8">
								<label :class="deliveryCenterCode=='CN_SHIP'?'active':'nonActive'" @click="onDelivery('CN_SHIP')">
									<div class="img-box">
										<img src="../../assets/list/order-ship.png" loading="lazy" alt="CN_SHIP">
										<div class="duration">
											주 6회 출고<br>
											국내 통관 평균 2~5일 소요
										</div>
									</div>
									<div class="delivery-name" >
									<!-- 	<input name="deliveryCenterCode" type="radio" class="type-radio" value="CN_SHIP"> -->
										<el-radio v-model="deliveryCenterCode" label="CN_SHIP" style="color: #000;" >해상</el-radio>
									<!-- 	<div style="margin-left: 10px;">해상</div> -->
									</div>
									
								</label>
							</el-col>
							<!-- <el-col :xs="24" :sm="8">
								<label :class="deliveryCenterCode=='CN_AIR'?'active':'nonActive'" @click="onDelivery('CN_AIR')">
									<div class="img-box">
										<img src="../../assets/list/order-air.png" loading="lazy" alt="CN_AIR">
										<div class="duration">
											주 6회 출고<br>
											국내 통관 평균 1일 소요
										</div>
									</div>
									<div class="delivery-name">
								
										<el-radio v-model="deliveryCenterCode" label="CN_AIR" style="color: #000;" >항공</el-radio>
							
									</div>
								</label>
							</el-col> -->
							<el-col :xs="24" :sm="8">
								<label :class="deliveryCenterCode=='CN_LCL'?'active':'nonActive'" @click="onDelivery('CN_LCL')">
									<div class="img-box">
										<img src="../../assets/list/order-ship.png" loading="lazy" alt="CN_LCL">
										<div class="duration">
											주 3회 출고<br>
											국내 통관 평균 1~3일 소요
										</div>
									</div>
									<div class="delivery-name">
										<el-radio v-model="deliveryCenterCode" label="CN_LCL" style="color: #000;" >화물</el-radio>
										<!-- <input name="deliveryCenterCode" type="radio" class="type-radio" value="CN_LCL">
										<div style="margin-left: 10px;">LCL화물</div> -->
									</div>
	
								</label>
							</el-col>
						</el-row>
					</div>
				</div>
				
				<div class="type-card shadow-bottom">
					<div class="card-head">통관방법 선택</div>
					<div class="card-body">
						<div class="card-help">신청서 작성시 폼목선택에 따라서 목록/간이 통관방법이 변경될수 있어요(사업자 통관은 해당사항 없음)</div>
						
						<el-row >
							<el-col :xs="24" :sm="8" v-if="show">
								<label class="cell" :class="customsType==2?'active':'nonActive'" @click="onCustomsType(2)">
									<div class="img-box">
										<img src="../../assets/list/order-custom2.png" loading="lazy" alt="CN_SHIP">
								
									</div>
									<div class="delivery-name" >
										<input name="customsType" type="radio" class="type-radio" value="2" v-model="customsType">
										<div style="margin-left: 10px;" class="background-color">목록통관
											<el-popover
												placement="top"
												width="400"
												trigger="hover"
												>
												<ul class="dot-list">
													<li>수수료:무료</li>
													<li>개인통관부호이용시</li>
													<li>자가 사용 150$ 이하일 경우</li>
													<li>자가사용목적 $150 초과혹은<br>목록통관 불가 상품이 있을경우 일반통관(간이)로 변경됩니다.</li>
													<li>목록통관취하시<br>목록통관취하수수료2,000원+간이통관수수료3,000원+(인천항창고관리비용)포장당1,500원</li>
												</ul>
												<i class="el-icon-question" style="color:var(--main-color);" slot="reference"></i>
											</el-popover>
										</div>
									</div>
									<router-link to="/bizCustomsInfo" class="link-btn type-2">
										통관안내 <i class="el-icon-top-right"></i>
									</router-link>
								</label>
							</el-col>
							<el-col :xs="24" :sm="8"  v-if="show">
								<label class="cell" :class="customsType==1?'active':'nonActive'" @click="onCustomsType(1)">
									<div class="img-box">
										<img src="../../assets/list/order-custom1.png" loading="lazy" alt="CN_AIR">
										
									</div>
									<div class="delivery-name">
										<input name="customsType" type="radio" class="type-radio" value="1" v-model="customsType">
										<div style="margin-left: 10px;" class="background-color">간이통관
											<el-popover
												placement="top"
												width="400"
												trigger="hover"
												>
												<ul class="dot-list">
													<li>수수료:3.000원</li>
													<li>개인통관부호이용시</li>
													<li>면세 범위 150$ 초과되거나, 목록통관 신고 불가 품목이 있을 경우 간이통관으로 진행됩니다.</li>
													<li>$2000 초과 시 관세사비용 11,000원+세관 창고료 실비 청구됩니다.</li>
												</ul>
												<i class="el-icon-question" style="color:var(--main-color);" slot="reference"></i>
											</el-popover>
										</div>
									</div>
									<router-link to="/bizCustomsInfo" class="link-btn type-2">
										통관안내 <i class="el-icon-top-right"></i>
									</router-link>
								</label>
							</el-col>
							<el-col :xs="24" :sm="8">
								<label class="cell" :class="customsType==3?'active':'nonActive'" @click="onCustomsType(3)">
									<div class="img-box">
										<img src="../../assets/list/order-custom3.png" loading="lazy" alt="CN_LCL">
										
									</div>
									<div class="delivery-name">
										<input name="customsType" type="radio" class="type-radio" value="3" v-model="customsType">
										<div style="margin-left: 10px;" class="background-color">사업자통관
											<el-popover
												placement="top"
												width="400"
												trigger="hover"
												>
												<ul class="dot-list">
													<li>관세사수수료:특송통관 : 18,000원,<br>LCL 수입화물 통관 : 30,000원 부가세별도</li>
													<li>사업자 영리목적으로 구매하실경우<br>구매금액 수량등 은 제한없음</li>
													<li>모든 수입물품의 원산지표기필수</li>
													<li>관/부가세 및 기타비용이 발생합니다.</li>
												</ul>
												<i class="el-icon-question" style="color:var(--main-color);" slot="reference"></i>
											</el-popover>
										</div>
										
									</div>
									<router-link to="/bizCustomsInfo" class="link-btn type-2">
										통관안내 <i class="el-icon-top-right"></i>
									</router-link>
								</label>
							</el-col>
						</el-row>
						
					</div>
				</div>
				
				<p class="text-center">
					<router-link 
						ref="submitBtn"
						:to="submitUrl" 
						style="background-color:rgb(247, 148, 29);" 
						class="btn btn-submit btn-lg" 
						@click.native.prevent="onSubmit"
					>
						구매대행 신청하기
					</router-link>
				</p>
			</div>			
			
		</div>
		
		
	</div>
</template>

<script>
	import AgencyBanner from '../../components/AgencyBanner.vue'
	export default {
		components: {
			AgencyBanner,
		},
		data() {
			return{
				show:true,
				checked: false,
				 
				agreement_yn:"",
				deliveryCenterCode:"",
				customsType:""
			}
		},
		computed: {
			submitUrl() {
				return `/agencyShoppingWrite?agreement_yn=${this.agreement_yn}&deliveryCenterCode=${this.deliveryCenterCode}&customsType=${this.customsType}`
			}
		},
		mounted() {
			const savedState = sessionStorage.getItem('agencyShoppingState');
			if (savedState) {
				const state = JSON.parse(savedState);
				this.checked = state.checked || false;
				this.agreement_yn = state.agreement_yn || "";
				this.deliveryCenterCode = state.deliveryCenterCode || "";
				this.customsType = state.customsType || "";
				this.show = state.show !== undefined ? state.show : true;
			}
			const scrollPos = sessionStorage.getItem('agencyShoppingScroll');
			if (scrollPos) {
				this.$nextTick(() => {
					window.scrollTo(0, parseInt(scrollPos));
				});
			}
		},
		beforeDestroy() {
			sessionStorage.setItem('agencyShoppingScroll', window.scrollY);
			sessionStorage.setItem('agencyShoppingState', JSON.stringify({
				checked: this.checked,
				agreement_yn: this.agreement_yn,
				deliveryCenterCode: this.deliveryCenterCode,
				customsType: this.customsType,
				show: this.show
			}));
		},
		methods: {
			onDelivery(index){
				console.log(index)
				this.deliveryCenterCode=index
				if(index == 'CN_LCL'){
					this.show = false
				}else{
					this.show = true
				}
				
			},
			onCustomsType(index){
				console.log(index)
				this.customsType=index
			},
			onCurrentNav(url){
				this.$router.push(url);	
			},
			agreementYn(){
				if(this.checked){
					this.agreement_yn=1
				}else{
					this.agreement_yn=""
				}
			},
			onSubmit(){
				if(this.agreement_yn != 1){
					alert("구매대행 작성시 주의사항에 동의해야 합니다.")
					return
				}
				if(this.deliveryCenterCode == ''){
					alert("배송대행지를 선택하세요.")
					return
				}
				if(this.customsType == ''){
					alert("통관유형을 선택하세요.")
					return
				}
				console.log("提交")
				this.$router.push(this.submitUrl)
				
			}
			
		}
	}
</script>

<style scoped>
	.agency-config-common h3 {
	    font-size: 36px;
	    font-weight: bold;
	    padding: 0 0 24px 20px;
	    border-bottom: 1px solid #bcbcbc;
	    position: relative;
	    margin: 0 0 50px;
	}
	.agency-config-common h3:before {
	    content: '';
	    display: block;
	    width: 10px;
	    height: 48px;
	    background: #ffd04b;
	    position: absolute;
	    left: 0;
	    top: -4px;
	}
	.agency-config-common .type-card {
	    margin-bottom: 50px;
	    overflow: visible;
	}
	.type-card.shadow-bottom {
	    box-shadow: 8px 12px 12px rgba(0, 0, 0, 0.06);
	}
	.type-card {
	    border: 1px solid var(--border-color);
	    border-radius: 26px;
	    overflow: hidden;
	}
	.agency-config-common .type-card .card-head {
	    height: 77px;
	    text-align: left;
	    justify-content: left;
	    font-size: 24px;
	    padding-left: 40px;
	    font-weight: bold;
	    border-top-left-radius: 26px;
	    border-top-right-radius: 26px;
	}
	.type-card > .card-head {
/* 	    font-weight: 700;
	    font-size: 20px;
	    height: 66px; */
	    line-height: normal;
	    display: flex;
	    align-items: center;
	/*    justify-content: center; */
	    color: #fff;
	    gap: 0 8px;
	    background: var(--secondary-color);
	}
	.agency-config-common .type-card .card-body {
	    padding: 35px 39px;
	    border-bottom-left-radius: 26px;
	    border-bottom-right-radius: 26px;
	}
	.type-card > .card-body {
	    background: #fff;
	}
	.agency-config-common .type-card .card-help {
	    font-size: 17px;
	    font-weight: 600;
	    color: var(--navy-color);
	    background: #f4f8ff;
	    padding: 12px 20px;
	    margin-bottom: 30px;
	}
	.agreement-box{
		/* border: 1px solid var(--border-color); */
		background: #F5F8FD;
		padding: 30px;
		margin-bottom: 9px;
		border-radius: 20px;
	}
	.height-fixed-box{
		background: #F5F8FD;
		height: 270px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.height-fixed-box p {
	    letter-spacing: -0.01em;
	    font-size: 15px;
	    line-height: 27px;
	    margin-bottom: 0;
	}
	.agency-config-common .checkbox {
	    margin: 20px 4px 17px 0;
	    text-align: right;
	}
	.agency-config-common .checkbox label {
	    font-size: 15px;
	    font-weight: 500;
	}
	.checkbox-inline input[type=checkbox] {
	    margin-left: -30px;
	    margin-top: 0;
	}
/* 	input.type-checkbox {
	    width: 14px;
	    height: 14px;
	} */
	.agency-config-common .img-box {
	    position: relative;
	    border-radius: var(--border-radius);
		margin:0 16px;
	    overflow: hidden;
	    margin-bottom: 22px;
	}
	.agency-config-common label {
		padding: 0 !important;
		margin: 0 !important;
		position: relative;
		text-align: center;
		font-weight: bold;
	}
	.cell{
		display: flex;
		flex-direction:column;
		align-items: center;
	}
	.agency-config-common .type-radio {
	    margin: 0;
	    position: relative;
	}
	.agency-config-common label.active .img-box:before {
	   /* border: 3px solid var(--main-color); */
	}
	.agency-config-common .img-box:before {
		content: "";
		display: block;
		width: 100%;
		height: 190px;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		border-radius: var(--border-radius);
	}
	.agency-config-common  label.nonActive .img-box:before {
	    background: rgba(0, 0, 0, 0.6);
		
	}
	.agency-config-common .duration {
	    position: absolute;
	    left: 24px;
	    bottom: 20px;
	    font-size: 15px;
	    font-weight: bold;
	    color: #fff;
	    text-align: left;
	}
	.delivery-name{
		display: flex;
		justify-content: center;
		color: val(--background-color);
	}
	.link-btn{
		margin-top: 10px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 19px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 7px 17px;
		width:100px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer;
	}
	.link-btn.type-2{
		color: var(--main-color);
		background: #fff;
	}
	.btn {
		border: none;
	    font-size: 15px;
	    border-radius: 14px;
	    position: relative;
	    text-align: center;
	    line-height: normal;
	}
	.btn-lg {
	    padding: 21px 35px;
	    font-size: 20px;
	    font-weight: bold;
	    min-width: 160px;
	    border-radius: 36px;
	}
	.btn-submit, .btn-submit:focus {
	    background-color: var(--main-color);
	    border-color: var(--main-color);
	    color: #fff !important;
		cursor: pointer;
	}

	
	
	ul.dot-list {
	    margin: 0;
	    padding: 10px 15px;
	  /*  list-style: none; */
	}
	.color-red {
	    color: #cc3333 !important;
	}
	a {
	    color: #337ab7;
	    text-decoration: none;
	}
	.text-center {
	    text-align: center !important;
	}
	.background-color{
		color:var(--background-color)
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:40px 10px;
		}
		.agency-config-common h3 {
		    font-size: 24px;
		    padding: 0 0 14px 12px;
		    margin: 0 0 20px;
		}
		.agency-config-common h3:before {
		    width: 4px;
		    height: 21px;
		    top: 2px;
		}
		.agency-config-common .type-card .card-head {
			height: 55px;
		    justify-content: start;
		    padding-left: 30px;
		    font-size: 17px;
		}
		.agency-config-common .type-card .card-help {
		    font-size: 15px;
		}
		.agency-config-common .type-card .card-body {
		    padding: 20px;
		    background: #fff;
		}
		.agency-config-common .checkbox label {
		    font-size: 12px;
		}
		.delivery-name{
			padding-bottom: 30px;
		}
		.link-btn{
			margin-top: 0;
			margin-bottom: 20px;
		}
		
		
	}
</style>